// src/utils/authStateListener.ts
import { supabase } from "src/boot/supabase";
import { useRouter } from "vue-router";

export function setupAuthStateListener() {
    const router = useRouter();

    supabase.auth.onAuthStateChange((event, session) => {
        console.log(`[🧭 Supabase Auth Event] ${event}`);

        if (event === "SIGNED_OUT" || !session) {
            console.warn("🛑 Sesja wygasła lub użytkownik się wylogował.");
            void router.push("/login");
        }
    });
}
